import { Pipe, PipeTransform } from '@angular/core';
import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'typeOfMenu',
  standalone: false,
})
export class TypeOfMenuPipe implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) { }

  transform(value: number): any {
    let type: string = '';

    switch (value) {
      case AppConst.MENU_DISP_TYPE_GUIDE:
        type = this.translate.instant('ガイドに表示する');
        break;
      case AppConst.MENU_DISP_TYPE_MENU:
        type = this.translate.instant('メニューに表示する');
        break;
    }
    return type;
  }

}
